import React from 'react';
import { Sectors } from '../components/Sectors';
export function SectorsPage() {
  return <div className="pt-24 min-h-screen bg-navy-light" data-id="element-245">
      <Sectors data-id="element-246" />
    </div>;
}